import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Card } from "@/components/portal/ui";
import { money } from "@/lib/constants";

const NAMES = { diagnostic: "Diagnostic", blueprint: "Blueprint", guided: "Guided", inhome_overnight: "In-Home + Overnight" };

function AggCard({ title, agg }) {
  const rows = Object.entries(agg || {}).sort((a, b) => b[1].gross - a[1].gross);
  return (
    <Card className="p-5">
      <div className="eyebrow text-[#9F634E] mb-3">{title}</div>
      {rows.map(([k, v]) => (
        <div key={k} className="flex justify-between text-sm border-b border-[#F0ECE4] py-1.5">
          <span className="text-[#1A1918]">{NAMES[k] || k || "—"}</span>
          <span className="text-[#6B665E]">{money(v.gross)} · {v.count}</span>
        </div>
      ))}
    </Card>
  );
}

export default function Ledger() {
  const [d, setD] = useState(null);
  useEffect(() => { http.get("/admin/ledger").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <p className="text-[#6B665E]">Loading…</p>;

  return (
    <div>
      <div className="eyebrow text-[#8A998C] mb-1">Property Revenue Ledger</div>
      <h1 className="font-display text-3xl text-[#1A1918] mb-1">Tuition &amp; Revenue</h1>
      <p className="text-[#6B665E] text-sm mb-8">Every transaction with first-touch attribution, content cluster, operator, and customer lifetime revenue.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        <AggCard title="By Source" agg={d.by_source} />
        <AggCard title="By Content Cluster" agg={d.by_cluster} />
        <AggCard title="By Product" agg={d.by_product} />
        <AggCard title="By Landing Page" agg={d.by_landing} />
      </div>

      <Card className="p-2 overflow-x-auto">
        <table className="w-full text-sm min-w-[820px]">
          <thead><tr className="text-[#8A998C] text-xs uppercase tracking-wide">
            {["Customer", "Date", "Product", "Gross", "Net", "Source", "Landing", "Cluster", "Lifetime"].map((h) => <th key={h} className="text-left p-3">{h}</th>)}
          </tr></thead>
          <tbody>
            {d.entries.map((e) => (
              <tr key={e.id} className="border-t border-[#F0ECE4]">
                <td className="p-3 text-[#1A1918]">{e.customer_label}</td>
                <td className="p-3 text-[#6B665E]">{new Date(e.date).toLocaleDateString()}</td>
                <td className="p-3 text-[#1A1918]">{NAMES[e.product] || e.product}</td>
                <td className="p-3 text-[#1A1918]">{money(e.gross)}</td>
                <td className="p-3 text-[#6B665E]">{money(e.net)}</td>
                <td className="p-3 text-[#6B665E]">{e.source}</td>
                <td className="p-3 text-[#6B665E] max-w-[160px] truncate">{e.landing}</td>
                <td className="p-3 text-[#6B665E]">{e.cluster || "—"}</td>
                <td className="p-3 text-[#1A1918]">{money(e.lifetime)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
